import React, { memo, useMemo } from 'react';

/**
 * ConversationTagsMC - Atom
 * Renderiza los tags de cliente en el chat usando Tailwind y estilos inline para color dinámico
 * @param {Array} tags - Array de tags [{ id, tag, tag_color, font_color }]
 */
const ConversationTagsMC = memo(({ tags = [] }) => {
  // Memoizar tags válidos para evitar renders innecesarios
  const validTags = useMemo(() => {
    if (!Array.isArray(tags)) return [];
    const seen = new Set();
    return tags.filter((tag) => {
      if (!tag || tag.id == null) return false;
      const id = String(tag.id);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, [tags]);

  if (!validTags.length) return null;

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-1">
      {validTags.map((tag) => (
        <div
          key={tag.id}
          className="tw-px-2 tw-py-1 tw-rounded tw-text-2xs tw-font-medium tw-border tw-border-solid tw-max-w-xs tw-truncate"
          style={{
            backgroundColor: tag.tag_color,
            color: tag.font_color,
            borderColor: tag.font_color
          }}
          title={tag.tag}
        >
          {tag.tag}
        </div>
      ))}
    </div>
  );
});

ConversationTagsMC.displayName = 'ConversationTagsMC';

export default ConversationTagsMC;
